export default {"src":"/_next/static/media/frontyard.0b6f0222.svg","height":56,"width":56,"blurWidth":0,"blurHeight":0};